module.exports = __webpack_public_path__ + "img/icon-speed-base.8ffd2892.svg";